import React, { useState } from 'react'
import { Chart } from 'react-google-charts'
import { SelectInput } from '../../../molecules/fields/SelectField'
import { MenuItem, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import { detailByType } from '../../../../configs/statisticConfig'
import DownloadDialog from '../DownloadDialog'
import DownloadChart from '../DownloadChart'
import { downloadTypes } from '../../../../constants/statistics'

const CustomChart = ({
  chartData,
  title,
  description,
  chartTitle,
  verticalTitle,
  horizontalTitle,
  typesChart = ['LineChart', 'BarChart'],
  onChangeChartType,
  excelKindDownload,
  downloadAvailable = [downloadTypes.picture]
}) => {
  const inputOptions = typesChart.map(option => ({ id: option, name: detailByType[option].name }))
  const [chartType, setChartType] = useState(typesChart[0])
  const [chartImageURI, setChartImageURI] = useState('')
  const [openDialog, setOpenDialog] = useState(false)

  const chartOptions = detailByType[chartType].options({
    hTitle: horizontalTitle,
    vTitle: verticalTitle,
    title: chartTitle
  })

  const handleChartTypeChange = event => {
    setChartType(event.target.value)
    onChangeChartType && onChangeChartType(event.target.value)
  }

  const chartEvents = [
    {
      eventName: 'ready',
      callback: ({ chartWrapper }) => {
        const chart = chartWrapper.getChart()
        setChartImageURI(chart.getImageURI())
      }
    }
  ]

  const handleClosePopup = () => {
    setOpenDialog(false)
  }

  return (
    <>
      <div className="md:flex block overflow-auto space-x-6 px-6 py-8 bg-neutral-100 row scrollable">
        <div className="lg:w-5/6 w-full pr-6">
          <div className="md:flex block justify-between pb-4 md:pb-0 items-center">
            <div className="w-full mr-4">
              <h2 className="md:text-left w-full md:w-auto font-bold text-2xl">{title}</h2>
              <p className="my-4">{description}</p>
            </div>
            <div className="w-48 min-w-48">
              <SelectInput value={chartType} onChange={handleChartTypeChange}>
                {inputOptions.map(option => (
                  <MenuItem value={option.id} key={option.id}>
                    <Typography className="text-base whitespace-normal leading-none pl-6 pr-6 py-2">
                      {option.name}
                    </Typography>
                  </MenuItem>
                ))}
              </SelectInput>
            </div>
          </div>
        </div>
      </div>
      <DownloadDialog popupInfo={{ show: openDialog, title }} onClosePopup={handleClosePopup} />
      <div className="flex lg:flex-row flex-col gap-6 px-6 bg-neutral-100 pb-8">
        <div className="lg:w-5/6 w-full">
          <Chart
            chartType={chartType}
            width="100%"
            height="500px"
            data={chartData}
            options={chartOptions}
            chartEvents={chartEvents}
          />
        </div>
        <div className="lg:w-1/6">
          <DownloadChart
            title={title}
            excelKindDownload={excelKindDownload}
            downloadAvailable={downloadAvailable}
            onExcelDownload={() => setOpenDialog(true)}
            chartImageURI={chartImageURI}
          />
        </div>
      </div>
    </>
  )
}

export default CustomChart

CustomChart.propTypes = {
  chartData: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  verticalTitle: PropTypes.string,
  horizontalTitle: PropTypes.string,
  chartTitle: PropTypes.string,
  typesChart: PropTypes.array,
  onChangeChartType: PropTypes.func,
  excelKindDownload: PropTypes.string,
  downloadAvailable: PropTypes.arrayOf(PropTypes.string)
}
